// eslint-disable-next-line
import { call, put, select, takeLatest } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//
import { store } from "./../firebase";

/*

  NB: Check sagas/db for the Init log grab

*/
function* handleLogs(action) {
  //Action value
  const { value } = action;

  //State values
  const appState = yield select();
  let cUID = appState.user.currentUser.client;
  const { email } = appState.user.currentUser.profile;

  if (action.filter === "login") {
    if (cUID) {
      yield store.log(cUID, {
        action: "login",
        message: "user login",
        user: email,
        value: value ? value : null
      });
    }
  }

  if (action.filter === "logout") {
    if (cUID) {
      yield call(store.log, cUID, {
        action: "logout",
        message: "user logout",
        user: email,
        value: value ? value : null
      });
    }
  }

  if (action.filter === "changeTemp") {
    if (cUID) {
      yield call(store.log, cUID, {
        action: "temperature",
        message: action.message,
        user: email,
        value: value ? value : null
      });
    }
  }

  if (action.filter === "changeLights") {
    if (cUID) {
      yield call(store.log, cUID, {
        action: "lights",
        message: "brightness changed",
        user: email,
        value: value ? value : null
      });
    }
  }

  //Delete docs
  if (action.filter === "delete") {
    cUID = appState.user.currentUser.cUID;
    action.payload.map((a, i) => store.del(cUID, a));
  }
}

export function* logsWatcher() {
  yield takeLatest(ACTIONS.HIT_LOGS, handleLogs);
}



// WEBPACK FOOTER //
// ./src/sagas/logs.js